export default __webpack_public_path__ + "static/media/temp stay volunteer.f2de4b23.jpg";